<template>
  <div class="popover-content">
    <div
      v-for="el in popoverContentObj"
      class="popover-content-item"
      @click="el.fn"
    >
      <IconBase
        :key="el.icon"
        :name="el.icon"
        size="20"
      />

      {{ el.text }}
    </div>
  </div>
</template>

<script setup lang="ts">
  import IconBase from '@/shared/ui/iconBase/IconBase.vue';

  const emit = defineEmits(['copy']);

  const getShareDate = () => {
    const url = window.location.href;
    const ogTitleMeta = document.querySelector('meta[name="og:title"]');
    const title: string | null = ogTitleMeta ? ogTitleMeta.getAttribute('content') : null;

    return {
      url,
      title,
    };
  };

  const popoverContentObj = [
    {
      text: 'Скопировать ссылку',
      icon: 'link',
      fn: async () => {
        const url = window.location.href;

        try {
          await navigator.clipboard.writeText(url);
          emit('copy');
        } catch {
          // Ignore clipboard errors
        }
      },
    },
    {
      text: 'Telegram',
      icon: 'tg',
      fn: () => {
        const data = getShareDate();

        window.open(`https://telegram.me/share/url?text=${data.title}&url=${data.url}`, '_blank');
      },
    },
    {
      text: 'ВКонтакте',
      icon: 'vk',
      fn: () => {
        const data = getShareDate();

        window.open(`http://vk.com/share.php?title=${data.title}&url=${data.url}`, '_blank');
      },
    },
  ];
</script>

<style lang="scss" scoped>
  .popover-container {
    position: relative;
  }

  .popover-content {
    display: flex;
    flex-direction: column;
  }

  .popover-content-item {
    display: flex;
    gap: 8px;
    align-items: center;
    box-sizing: border-box;
    min-width: 245px;
    padding: 12px;
    border-radius: 8px;
    cursor: pointer;

    &:hover {
      background-color: var(--comp-dropdown-menu-item-color-background-hovered);
    }

    @include base-400-400-regular;
  }
</style>
